import apiCalls from "../../config/apiCalls";
import Headers from "../../config/headers";
import { keyMapsMutation } from "../../helpers/storeKeys";
import LocalStorageFunc from "../../helpers/localStorageFunc";

export default {
  namespaced: true,
  state: {
    SavedCardDetails: [],
  },
  getters: {},
  mutations: {
    updateSavedCardDetails(state, payload) {
      state.SavedCardDetails = payload;
    },
  },
  actions: {
    getSavedCardPaymentModes({ commit }, payload) {
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      apiCalls
        .SAVED_CARDS_API({
          headers: { ...Headers({ mid: true, xTenantID: true }) },
        })
        .then(function (response) {
          if (response?.data) {
            commit(
              "updateSavedCardDetails",
              response?.data?.unifiedCardsResponse?.cards
            );
          }
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        });
    },
    deleteSavedCardsApi({ commit, dispatch }, payload) {
      apiCalls
        .DELETE_SAVED_CARDS_API({
          headers: Headers(),
          payload: {
            userId: LocalStorageFunc.getUserId(),
            cardId: payload?.cardId,
          },
        })
        .then(function (response) {
          if (response?.data?.status == "SUCCESS") {
            dispatch("getSavedCardPaymentModes", payload);
          }
        })
        .catch(function (error) {});
    },
    getWalletTransactionData({ commit }, payload) {
      commit(keyMapsMutation.UPDATE_LOADING_STATE, true, {
        root: true,
      });
      apiCalls
        .WALLET_TRANSACTIONS_API({
          headers: { ...Headers() },
          payload,
        })
        .then(function (response) {
          if (response?.data) {
            if (response?.data?.data) {
              if (response?.data?.data.length) {
                commit("updateWalletTransactions", response?.data?.data);
                commit("updateCurrentPage", payload.pageNo);
              } else {
                commit("updateLastPageReached", true);
              }
            }
            if (response?.data?.totalBalance) {
              commit("updateWalletBalance", response?.data?.totalBalance);
            }
            commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
              root: true,
            });
          }
        })
        .catch(function (error) {
          commit(keyMapsMutation.UPDATE_LOADING_STATE, false, {
            root: true,
          });
        });
    },
  },
};
